<template>
  <label
    class="OptionTile"
    :class="[{ isSelected }, optionIcons ? 'withIcon' : 'withoutIcon' ]"
    :data-testing-target="`Option: ${option.value}`"
  >
    <img v-if="optionIcons" :src="optionIcons[option.value].src" :alt="option.value" class="icon">
    <div v-if="optionIcons" class="text">{{ option.text }}</div>
    <input
      :type="radio ? 'radio' : 'checkbox'"
      v-bind="{ disabled }"
      :name="fieldName"
      :value="option.value"
      class="checkbox"
      :checked="isSelected"
    >
    <div v-if="!optionIcons" class="text">{{ option.text }}</div>
  </label>
</template>

<script>
export default {
  props: {
    option: Object,
    fieldName: String,
    radio: Boolean,
    disabled: Boolean,
    isSelected: Boolean,
    optionIcons: Object,
  },
}
</script>

<style scoped>

.OptionTile {
  border: thin solid #E9E9E9;
  border-radius: 8px;
  transition: all 0.15s;
  background-color: white;
}

.OptionTile:focus-visible {
  outline: none;
}

.OptionTile.isSelected {
  border-color: #B5BDC8;
  background-color: #F9F9F9;
}

.OptionTile:hover, .OptionTile:focus {
  border-color: #B5BDC8;
  background-color: #F1F0F0;
}


/* Without icon */

.OptionTile.withoutIcon {
  display: flex;
  align-items: center;
  max-width: 34rem;
  padding: var(--spacing-3) var(--spacing-4);
  cursor: pointer;
}

.OptionTile.withoutIcon .text {
  margin-left: var(--spacing-4);
  font-weight: 600;
  font-size: var(--font-size-2);
  color: var(--text-color-dark);
}

.OptionTile.withoutIcon .checkbox {
  width: 1.5rem;
  height: 1.5rem;
  cursor: inherit;
}


/* With icon */

.OptionTile.withIcon {
  --tile-font-size: var(--font-size-1);
  display: grid;
  grid-template: 3rem 1fr auto / 100%;
  justify-items: center;
  padding: var(--spacing-3) var(--spacing-5) var(--spacing-6);
  gap: var(--spacing-2);
  cursor: pointer;
}

.OptionTile.withIcon.--large {
  --tile-font-size: var(--font-size-3);
  padding: var(--spacing-11) var(--spacing-10);
  gap: var(--spacing-5);
}

.OptionTile.withIcon .icon {
  align-self: center;
  max-height: 100%;
}

.OptionTile.withIcon .text {
  text-align: center;
  font-weight: 600;
  font-size: var(--tile-font-size);
  line-height: 1.3;
  color: var(--text-color-dark);
}

.OptionTile.withIcon .checkbox {
  width: 1.5rem;
  height: 1.5rem;
  cursor: inherit;
}

@media (--screen-sm) {
  .OptionTile.withIcon {
    grid-template-rows: 4rem 1fr auto;
  }
}

@media (--screen-lg) {
  .OptionTile.withIcon {
    grid-template-rows: 5rem 1fr auto;
  }
}
</style>
